import { Component } from 'shimmer'

import { Loader } from '@/utils/Loader'
import { webGL } from '@/webGL/WebGL'

import { MeshStandardMaterial } from 'three'

export class District extends Component {
  constructor (url) {
    super('District')

    this.promise = new Promise(resolve => {
      this.resolve = resolve
    })

    this.promises = []

    this.promises.push(this.addItem(url))

    this.scale.set(200, 200, 200)

    Promise.all(this.promises).then(this.resolve)
  }

  async addItem (url) {
    this.item = await Loader.load(url, true, this.setupItem)

    this.add(this.item)

    return
  }

  setupItem (obj) {
    obj.castShadow = true
    // obj.receiveShadow = true
    // obj.material = new MeshStandardMaterial({
    //   color: 0xff0000,
    //   emissive: 0x30000,
    //   roughness: .7,
    //   metalness: 1
    // })
  }
}